import { NgxUiSidenavModule } from './ngx-ui-sidenav/ngx-ui-sidenav.module';
import { NgxUiTabModule } from './ngx-ui-tab/ngx-ui-tab.module';
import { NgModule } from '@angular/core';
import { NgxUiToolingComponent } from './ngx-ui-tooling.component';
import { ComponentFactoryComponent } from './shared/component-factory/component-factory.component';
import { NgxUiFooterTaskbarModule } from './ngx-ui-footer-taskbar/ngx-ui-footer-taskbar.module';
import { NgxUiSidebarContentModule } from './ngx-sidebar-content/ngx-ui-sidebar-content.module';


@NgModule({
    imports: [
        NgxUiTabModule,
        NgxUiSidenavModule,
        NgxUiFooterTaskbarModule,
        NgxUiSidebarContentModule
    ],
    declarations: [
        NgxUiToolingComponent,
        ComponentFactoryComponent
    ],
    exports: [NgxUiToolingComponent, ComponentFactoryComponent]
})
export class NgxUiToolingModule {

}
